module.exports = __webpack_public_path__ + "static/img/index2(1)_06.7e0c5c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index2(1)_06.png
// module id = 3121
// module chunks = 1